import axios from 'axios';
import { ensureHttpsUrl, normalizeHttpsUrls } from '../utils/helpers/url.helpers';

const axiosInstance = axios.create({
  baseURL: `${ensureHttpsUrl('https://store.nexlanka.com')}/wp-json`,
  withCredentials: true, 
  headers: {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  },
});

axiosInstance.interceptors.response.use(
  (response) => ({
    ...response,
    data: normalizeHttpsUrls(response.data),
  }),
  (error) => {
    console.error('Axios Interceptor Error:', error.response?.status, error.response?.data);
    return Promise.reject(error);
  }
);

export default axiosInstance;